<template>

  <div>

    <div class="hit-panel hit-panel-default">

        <div class="hit-panel-body hit-text-center" >

          <div class="hit-form-group">

            <div class="eyecatcher" v-html="unread_chats.length"/>
            <div class="hit-html-small" v-html="$t('message.unreadChats')"/>

          </div>

        </div>

        <router-link v-if="unread_chats.length" :to="{name: 'unread_chats', params: { lang: $store.getters.lang }}" class="hit-btn hit-btn-default hit-btn-block" v-html="$t('message.goTo', {name: $t('message.userChat')})" />

    </div>

  </div>

</template>

<script>

import md5 from 'js-md5'

export default{

  data () {
    return {
      unread_chats: [],
      openChat: false
    }
  },

  methods: {

    get_md5: function (data) {
      return md5('' + data)
    },

    get_chat_messages: function () {
      var my_class = this

      if (typeof my_class.$store.getters.unread_chats === 'object') {
        my_class.unread_chats = this.$store.getters.unread_chatnr
        return false
      }

      this.$store.dispatch('get_unread_chats', function () {
        console.log(my_class.$store.getters.unread_chatnr)

        my_class.unread_chats = my_class.$store.getters.unread_chatnr
      })
    }

  },

  created () {
    this.get_chat_messages()
  }
}

</script>

<style scoped>

blockquote{
	border: 0;
	text-align: center;
}

</style>
